<template>
  <el-dialog
    :visible="innerShowFlag"
    :title="title"
    @close="closeHandle"
    append-to-body
    center
    width="30%"
    :close-on-click-modal="false"
  >

    <div v-if="typeFlag == 1">
      <el-input
        clearable
        :placeholder="$t('label_932')"
        v-model="filterTypeText">
      </el-input>
      <div style="height: 450px; overflow: auto">
        <el-tree
          :props="treeProp"
          :data="dataList"
          class="filter-tree"
          :filter-node-method="filterTypeNode"
          ref="typeTree"
          accordion
          show-checkbox
        >
        </el-tree>
      </div>
      <div class="tableMes2">
        <div style="margin: auto;">
							<span slot="footer" class="dialog-footer" style="display: flex;">
								<div ref="typeReplenish" class="chooseButton sendButton" @click="commitHandle">{{ $t('btn_20') }}</div>
							</span>
        </div>
      </div>
    </div>
    <div v-else-if="typeFlag == 0">
      <el-input
        clearable
        :placeholder="$t('label_932')"
        v-model="filterOrgText">
      </el-input>
      <div style="height: 450px; overflow: auto">
        <el-tree
          :props="treeProp"
          :data="dataList"
          class="filter-tree"
          :filter-node-method="filterOrgNode"
          ref="orgTree"
          accordion
          show-checkbox
        >
        </el-tree>
      </div>
      <div class="tableMes2">
        <div style="margin: auto;">
							<span slot="footer" class="dialog-footer" style="display: flex;">
								<div ref="orgReplenish" class="chooseButton sendButton" @click="commitHandle">
                  {{ $t('btn_20') }}
                </div>
							</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "selectTree",
  props: {
    showFlag: {
      type: Boolean,
      default: false,
    },
    typeFlag: {
      type: Number, // 0: 区域 1: 设备类型
    },
    treeNodes: {
      type: Array,
      default: [],
    }
  },
  watch: {
    showFlag(val) {
      this.innerShowFlag = val;
      if (val) {
        this.dataList = this.treeNodes;
      } else {
        this.dataList = [];
      }
    },
    filterOrgText(val) {
      this.$refs.orgTree.filter(val);
    },
    filterTypeText(val) {
      this.$refs.typeTree.filter(val);
    },
    // typeFlag(val) {
    //   if (val == 0) {
    //     this.title = "区域选择"
    //   } else if (val == 1) {
    //     this.title = "类型选择"
    //   }
    // },
  },
  data() {
    return {
      filterOrgText: '',
      filterTypeText: '',
      loading: false,
      title: this.$t('label_942'),
      treeProp: {
        children: 'children',
        label: 'label'
      },
      selectedList: [],
      dataList: [],
      innerShowFlag: false,
    }
  },
  methods: {
    closeHandle() {
      // this.treeNodes = [];
      this.filterOrgText = "";
      this.filterTypeText = "";
      this.selectedList = [];
      // this.showFlag = false;
      this.$emit("selectTreeCloseHandle", false);
    },
    commitHandle() {
      if (this.typeFlag == 0) {
        console.log(this.$refs.orgTree.getCheckedNodes());
        this.$emit("getSelectedList", this.$refs.orgTree.getCheckedNodes())
      } else {
        console.log(this.$refs.typeTree.getCheckedNodes());
        this.$emit("getSelectedList", this.$refs.typeTree.getCheckedNodes())
      }
      this.innerShowFlag = false;
    },
    filterOrgNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.indexOf(value) !== -1;
    },
    filterTypeNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.indexOf(value) !== -1;
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list/tree/selectTree.vue